"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../common/utils");
const removeRoot = (wrapperItems) => {
    return (name) => {
        if (name) {
            const isDeleted = wrapperItems.delete(name);
            if (!isDeleted) {
                throw new Error(`${utils_1.logPrefix} failed to delete ${name}, key not found!`);
            }
        }
        else {
            wrapperItems.clear();
        }
    };
};
exports.removeRoot = removeRoot;
//# sourceMappingURL=remove-root.js.map